import useScopedTranslation from 'hooks/useScopedTranslation';
import { docMgmtI18n } from '../../i18n';
import { putDocumentSendUpdateStatus } from '../../../../services/documentManagementServices';

const ModalCancelRequest = ({
  DesignSystemComponents,
  show,
  onClose,
  documentId,
  onSuccess,
  startGlobalLoading,
  stopGlobalLoading,
  userId,
}) => {
  const { Modal } = DesignSystemComponents;

  const { t } = useScopedTranslation(docMgmtI18n);

  const handleCancelRequest = async () => {
    startGlobalLoading();
    try {
      await putDocumentSendUpdateStatus.putUpdateStatus({
        id: documentId,
        userId,
        statusId: 4,
        observation: '',
        updatedAt: new Date()
          .toLocaleString('sv-SE', { timeZone: 'America/Santiago' })
          .replace(' ', 'T'),
      });
      if (onSuccess) onSuccess();
      onClose();
    } catch (err) {
      console.warn('Error cancelling request:', err);
    } finally {
      stopGlobalLoading();
    }
  };

  return (
    <Modal
      title={t('dm_cancel_title')}
      show={show}
      onClose={onClose}
      primaryBtnTxt={t('dm_cancel_confirm')}
      primaryBtnAction={handleCancelRequest}
      secondaryBtnTxt={t('dm_cancel_close')}
      secondaryBtnAction={onClose}
      ctaAligment='right'
      width='520px'
    >
      <p className='body'>
        {t('dm_cancel_message')}
      </p>
    </Modal>
  );
};

export default ModalCancelRequest;
